import { render, staticRenderFns } from "./MasterImport.vue?vue&type=template&id=2f60b516&scoped=true"
import script from "./MasterImport.vue?vue&type=script&lang=js"
export * from "./MasterImport.vue?vue&type=script&lang=js"
import style0 from "./MasterImport.vue?vue&type=style&index=0&id=2f60b516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60b516",
  null
  
)

export default component.exports